"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const bulkgiftcardsbrand04 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 71 52",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-bulkgiftcardsbrand04` : '') + (description ? ` desc-bulkgiftcardsbrand04` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-bulkgiftcardsbrand04"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-bulkgiftcardsbrand04"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M55.542 4.432a3.044 3.044 0 0 1 3.044 3.045v3.045h3.043a3.044 3.044 0 0 1 3.044 3.044v3.045h3.043a3.044 3.044 0 0 1 3.044 3.045v29.3A3.044 3.044 0 0 1 67.716 52H20.41a3.044 3.044 0 0 1-3.044-3.045V45.91h-3.043a3.044 3.044 0 0 1-3.044-3.044V39.82H8.235a3.044 3.044 0 0 1-3.044-3.045v-29.3a3.044 3.044 0 0 1 3.044-3.044h47.307Z",
    fill: "#F1C4DC",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#D01481"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.891 8.85a2.044 2.044 0 0 0-2.043 2.046v29.299c0 1.13.915 2.045 2.043 2.045h2.044V16.96l.004-.152v-.025a4.044 4.044 0 0 1 4.04-3.844h43.263v-2.044c0-1.13-.915-2.045-2.043-2.045H10.89Zm-4.043 2.046A4.044 4.044 0 0 1 10.89 6.85H58.2a4.044 4.044 0 0 1 4.043 4.045v3.044a1 1 0 0 1-1 1H16.978c-1.09 0-1.981.855-2.04 1.931l-.003.126V43.24a1 1 0 0 1-1 1H10.89a4.044 4.044 0 0 1-4.043-4.044v-29.3Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.978 14.94a2.044 2.044 0 0 0-2.043 2.045v29.3c0 1.13.915 2.044 2.043 2.044h47.308a2.044 2.044 0 0 0 2.043-2.044v-29.3c0-1.13-.915-2.045-2.043-2.045H16.978Zm-4.043 2.045a4.044 4.044 0 0 1 4.043-4.045h47.308a4.044 4.044 0 0 1 4.043 4.045v29.3a4.044 4.044 0 0 1-4.043 4.044H16.978a4.044 4.044 0 0 1-4.043-4.044v-29.3Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.804 2.761a2.044 2.044 0 0 0-2.043 2.045v29.3c0 1.129.915 2.044 2.043 2.044h2.044V10.871l.004-.152v-.024a4.044 4.044 0 0 1 4.04-3.844h43.263V4.806c0-1.13-.915-2.045-2.043-2.045H4.804ZM.761 4.806A4.044 4.044 0 0 1 4.804.761h47.308a4.044 4.044 0 0 1 4.043 4.045v3.045a1 1 0 0 1-1 1H10.89c-1.09 0-1.981.854-2.04 1.93l-.003.127V37.15a1 1 0 0 1-1 1H4.804a4.044 4.044 0 0 1-4.043-4.045V4.806ZM29.663 30.835a1 1 0 0 1 1.414 0l6.147 6.15a1 1 0 0 1-1.415 1.415l-6.147-6.15a1 1 0 0 1 0-1.415Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.076 30.835a1 1 0 0 1 0 1.415L24.93 38.4a1 1 0 0 1-1.415-1.414l6.147-6.15a1 1 0 0 1 1.414 0Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.984 26.57a2.127 2.127 0 0 0-2.568.338l-3.633 3.635h5.137a2.128 2.128 0 0 0 1.064-3.973Zm-3.983-1.076a4.127 4.127 0 0 1 6.906 3.989 4.128 4.128 0 0 1-3.987 3.06h-7.55a1 1 0 0 1-.708-1.707l5.34-5.341Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m25.738 25.495 5.339 5.34a1 1 0 0 1-.708 1.708h-7.55a4.128 4.128 0 1 1 2.919-7.048Zm-1.415 1.413a2.127 2.127 0 0 0-3.56 2.057 2.128 2.128 0 0 0 2.056 1.578h5.137l-3.633-3.635Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.268 30.635h52.727v2H14.268v-2Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.287 49.663V14.274h2v35.389h-2Z"
  }))));
};
var _default = exports.default = bulkgiftcardsbrand04;